/* eslint-disable no-unsafe-optional-chaining */

import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import NtxPeoples2 from '../../../NTX/Peoples/NtxPeoples2';

const Update = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const { name } = location?.state;

  return (
    <div>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: ':moduleHome'
          },
          {
            name: t('الموردين'),
            link: '/PurchasesSettings/SUPPLIERS'
          },
          {
            name: t('تعديل المورد'),
            link: null
          }
        ]}
        PageName='تعديل بيانات المورد'
        subtitle={name}
      />

      <NtxPeoples2 isUpdate={true} typeCode='SUPPLIERS' parentId={null} />
    </div>
  );
};

export default Update;
